import { Icon } from "@iconify/react";
import { Button } from "@heroui/button";
import { Input } from "@heroui/input";
import React from "react";

const SearchInput = () => {
  return (
    <Input
      aria-label="Search"
      classNames={{
        base: "p-0",
        inputWrapper: "bg-foreground-50 border border-foreground-200 ",
        input: "text-base",
      }}
      endContent={
        <Button
          className="text-white px-5 rounded-lg"
          color="primary"
          size="sm"
        >
          Search
        </Button>
      }
      placeholder="Enter the service you need"
      startContent={
        <span className="flex items-center space-x-2 text-foreground">
          <Icon icon="ri:search-2-fill" />{" "}
          <span className=" whitespace-nowrap ">I need a -</span>
        </span>
      }
      type="search"
    />
  );
};

export default SearchInput;
